<template>
  <TimerLabel :seconds="timerSecs" />
</template>

<script>
import moment from 'moment-timezone'
import TimerLabel from '@/components/TimerLabel'

const getNumber = (v) => !v || isNaN(v) ? 0 : Number(v)
const second = 1000

export default {
  components: {
    TimerLabel
  },

  props: {
    value: {
      type: Number
    }
  },

  data () {
    const seconds = getNumber(this.value)
    const timerSecs = seconds
    const startSecs = Math.floor(Date.now() / second)
    return { seconds, timerSecs, startSecs }
  },

  mounted () {
    const vue = this
    vue.timeout = null
    vue.interval = null

    const calcSecs = () => {
      const endSecs = Math.floor(Date.now() / second)
      vue.timerSecs = vue.seconds + (endSecs - this.startSecs)
    }

    const setSecs = () => {
      calcSecs()
      vue.interval = setInterval(calcSecs, second)
    }

    const msNextSecond = second - parseInt(moment().format('SSS'), 10)
    if (msNextSecond < 15) return setSecs()

    vue.timeout = setTimeout(setSecs, msNextSecond)
  },

  beforeDestroy () {
    const vue = this
    vue.timeout && clearTimeout(vue.timeout)
    vue.interval && clearInterval(vue.interval)
  },

  watch: {
    value (value) {
      this.seconds = getNumber(value)
      this.startSecs = Math.floor(Date.now() / second)
    }
  }
}
</script>
